import { SelfContainedCommand, CommandExecutionContext } from '../../../../types/commands';
import { StandardToolResult, createSuccessResult, createErrorResult } from '../../../../types/standardToolResults';

export const automation_list: SelfContainedCommand = {
  id: 'automation_list',
  description: 'List the user\'s automations (scheduled agents and background tasks)',
  autonomyLevel: 'auto',
  visualTreatment: 'silent',

  schema: {
    parameters: [
      {
        name: 'enabled',
        type: 'boolean',
        description: 'Filter by enabled status. Omit to return all automations.',
        required: false,
      },
    ],
  },

  examples: {
    good: [
      {
        input: {},
        expectedOutput: createSuccessResult('Found 3 automations', { automations: [], count: 0 }),
        description: 'List all automations',
      },
      {
        input: { enabled: true },
        expectedOutput: createSuccessResult('Found 2 active automations', { automations: [], count: 0 }),
        description: 'List only enabled automations',
      },
    ],
    bad: [],
  },

  handler: async (params: any, context: CommandExecutionContext): Promise<StandardToolResult> => {
    try {
      const { default: useEntityStore } = await import('../../../../stores/entityStore');
      const entities = useEntityStore.getState().entities;

      let automations = entities
        .filter((e: any) => e.entityType === 'Automation' && e.skeleton?.visibility !== 'internal')
        .map((e: any) => ({
          id: e._id,
          name: e.name,
          enabled: e.skeleton?.enabled ?? true,
          triggerType: e.skeleton?.triggers?.[0]?.type,
          humanFrequency: e.skeleton?.triggers?.[0]?.humanFrequency,
          cron: e.skeleton?.triggers?.[0]?.cron,
          lastRunAt: e.skeleton?.lastRunAt,
          lastError: e.skeleton?.lastError,
          runCount: e.skeleton?.runCount ?? 0,
        }));

      if (params.enabled !== undefined) {
        automations = automations.filter((a) => a.enabled === params.enabled);
      }

      return createSuccessResult(
        `Found ${automations.length} automation${automations.length !== 1 ? 's' : ''}`,
        { automations, count: automations.length }
      );
    } catch (error: any) {
      return createErrorResult('Failed to list automations', error.message || 'Unknown error', 'execution');
    }
  },
};
